import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const MPPreset = definePreset(Aura, {
   semantic: {
      colorScheme: {
         dark: {
            surface: {
               0: '#FFFFFF',
               50: '#EFE4F1',
               100: '#DCCEE2',
               200: '#C7B3D1',
               300: '#B099C0',
               400: '#9A85AA',
               500: '#877594',
               600: '#6D5B79',
               700: '#61506B',
               800: '#53435F',
               900: '#3B2C47',
               950: '#2F1C3A',
               1000: '#241630',
            },
         },
         light: {
            surface: {
               0: '#FFFFFF',
               50: '#EFE4F1',
               100: '#DCCEE2',
               200: '#C7B3D1',
               300: '#B099C0',
               400: '#9A85AA',
               500: '#877594',
               600: '#6D5B79',
               700: '#61506B',
               800: '#53435F',
               900: '#3B2C47',
               950: '#2F1C3A',
               1000: '#241630',
            },
         },
      },
      primary: {
         color: '#f4f4f4',
         50: '#E2DAEA',
         100: '#D2C2DD',
         200: '#BDA9C9',
         300: '#A892B4',
         400: '#9A85AA',
         500: '#867296',
         600: '#705F80',
         700: '#594B69',
         800: '#453855',
         900: '#31263F',
      },
      neutral: {
         color: '#F4F4F4',
         0: '#FFFFFF',
         50: '#FFFFFF',
         100: '#F4F4F4',
         200: '#E8E8E8',
         300: '#D1D1D1',
         400: '#BABABA',
         500: '#A3A3A3',
         600: '#757575',
         700: '#474747',
         800: '#303030',
         900: '#191919',
      },
      vibrant: {
         color: '#B076E7',
      },
      red: {
         400: '#b00020',
         500: '#b00020',
      },
      formField: {
         color: '{neutral.600}',
         background: '{surface.800}',
         hover: {
            border: {
               color: '{neutral.500}',
            }
         },
         focus: {
            border: {
               color: '{neutral.300}',
            },
            color: '{neutral.0}',
         },
         placeholder: {
            color: '{neutral.400}',
         },
         disabled: {
            background: '{surface.900}',
            color: '{neutral.200}',
         },
         invalid: {
            border: {
               color: '{red.500}',
            },
            placeholder: {
               color: '{red.500}',
            }
         },
         lg: {
            fontSize: '1.4rem',
            paddingX: '1.25rem',
            paddingY: '1.25rem',
         },
      },
   },
   components: {
      toast: {
         secondary: {
            background: '{surface.1000}',
            color: '{neutral.200}',
            outline: '{surface.900}',
         },
      },
      card: {
         subtitle: {
            color: '{neutral.400}',
         },
         body: {
            padding: '1.6rem',
         },
         caption: {
            gap: '0.8rem',
         }
      },
      checkbox: {
         filled: {
            background: '{surface.0}',
         },
         border: {
            color: '{neutral.400}',
            radius: '0.2rem',
         },
         icon: {
            checked: {
               color: '{surface.0}',
            },
            size: '1.2rem',
            lg: {
               size: '1.4rem',
            }
         },
         checked: {
            background: '{surface.500}',
            border: {
               color: '{surface.500}',
            }
         },
         height: '1.6rem',
         width: '1.6rem',
         sm: {
            height: '1.4rem',
            width: '1.4rem',
         },
         lg: {
            height: '1.8rem',
            width: '1.8rem',
         },
      },
      tabs: {
         tab: {
            color: '{neutral.200}',
         },
      },
      select: {
         color: '{neutral.600}',
         overlay: {
            background: '{surface.900}',
            border: {
               color: '{surface.1000}',
            }
         },
         list: {
            padding: '0.8rem',
         },
      },
      accordion: {
         header: {
            color: '{neutral.0}',
            toggle: {
               icon: {
                  color: '{neutral.0}',
               }
            }
         },
         panel: {
            border: {
               color: '{surface.900}',
            },
         },
      },
      dialog: {
         background: '{surface.800}',
      },
      radiobutton: {
         width: '2rem',
         height: '2rem',
         border: {
            color: '{neutral.400}',
         },
         background: '{surface.900}',
         icon: {
            size: '1rem',
            checked: {
               color: '#c77bff',
            },
         },
         checked: {
            background: '{surface.900}',
         }
      },
      button: {
         text: {
            secondary: {
               color: '{neutral.400}',
            }
         },
         paddingX: '3.2rem',
         paddingY: '1.6rem',
         sm: {
            fontSize: '1.2rem',
            paddingX: '1rem',
            paddingY: '0.8rem',
         },
         lg: {
            fontSize: '1.6rem',
            paddingX: '4rem',
            paddingY: '0.8rem',
         },
      },
      breadcrumb: {
         item: {
            color: '{neutral.50}',
         },
      },
   },
});
